const links = [
    {
        id: 1,
        tolink: '/',
        namelink: 'English book'
    },
    {
        id: 2,
        tolink: 'es',
        namelink: 'Libro en Español'
    },
    /*{
        id: 3,
        tolink: 'home03',
        namelink: 'Training'
    },*/
    /*
    {
        id: 4,
        tolink: 'home02',
        namelink: 'Home 04'
    },*/
];


export default links ;